export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  console.error("❌ NEXT_PUBLIC_API_BASE_URL is not defined in .env");
}

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  // Headers communs - MODIFIÉ
  getHeaders(includeAuth = true, isFormData = false) {
    console.log('🔐 [ApiService] getHeaders appelé, includeAuth:', includeAuth, 'isFormData:', isFormData);
    
    const headers = {};

    // NE PAS définir Content-Type pour FormData
    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
      console.log('📋 [ApiService] Content-Type défini: application/json');
    } else {
      console.log('📋 [ApiService] FormData - Content-Type laissé au navigateur');
    }

    if (includeAuth) {
      console.log('🔐 [ApiService] Recherche token dans localStorage...');
      
      const token = localStorage.getItem('authToken');
      
      console.log('🔐 [ApiService] Token récupéré:', token ? 'PRÉSENT' : 'ABSENT');
      
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
        console.log('✅ [ApiService] Authorization header ajouté');
      } else {
        console.error('❌ [ApiService] AUCUN TOKEN TROUVÉ');
      }
    }

    console.log('📋 [ApiService] Headers FINAUX:', headers);
    return headers;
  }

  // Gestion des réponses
  async handleResponse(response) {
    console.log('🔐 [ApiService] Réponse reçue:', {
      status: response.status,
      statusText: response.statusText,
      url: response.url,
      ok: response.ok
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ [ApiService] Erreur réponse brute:', errorText);
      
      let errorData;
      try {
        errorData = JSON.parse(errorText);
        console.error('❌ [ApiService] Erreur parsée:', errorData);
      } catch {
        errorData = { message: 'Erreur réseau ou serveur' };
        console.error('❌ [ApiService] Impossible de parser erreur');
      }
      
      throw new Error(errorData.message || `Erreur ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ [ApiService] Données reçues avec succès:', data);
    
    if (!data.success) {
      console.error('❌ [ApiService] Réponse sans success:', data);
      throw new Error(data.message || 'Erreur inconnue');
    }

    console.log('✅ [ApiService] Requête réussie');
    return data;
  }

  // Méthodes HTTP génériques

  async get(endpoint, params = {}) {
    console.log('🚀 [ApiService] GET request:', `${this.baseURL}${endpoint}`, params);
    
    const url = new URL(`${this.baseURL}${endpoint}`);
    Object.keys(params).forEach(key => 
      url.searchParams.append(key, params[key])
    );

    console.log('🔐 [ApiService] URL finale:', url.toString());

    try {
      const headers = this.getHeaders();
      console.log('🔐 [ApiService] Headers utilisés pour GET:', headers);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: headers,
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('❌ [ApiService] Erreur dans get:', error);
      throw error;
    }
  }

  // MODIFIÉ: ajout du paramètre isFormData
  async post(endpoint, data = {}, isFormData = false) {
    console.log('🚀 [ApiService] POST request:', `${this.baseURL}${endpoint}`, data, 'isFormData:', isFormData);
    
    try {
      const headers = this.getHeaders(true, isFormData);
      console.log('🔐 [ApiService] Headers utilisés pour POST:', headers);
      
      const requestOptions = {
        method: 'POST',
        headers: headers,
      };

      // Gérer différemment FormData vs JSON
      if (isFormData) {
        requestOptions.body = data; // data est déjà un FormData
      } else {
        requestOptions.body = JSON.stringify(data);
      }
      
      console.log('📦 [ApiService] Corps de la requête:', isFormData ? 'FormData' : 'JSON');
      
      const response = await fetch(`${this.baseURL}${endpoint}`, requestOptions);
      return await this.handleResponse(response);
    } catch (error) {
      console.error('❌ [ApiService] Erreur dans post:', error);
      throw error;
    }
  }

  async put(endpoint, data = {}, isFormData = false) {
    console.log('🚀 [ApiService] PUT request:', `${this.baseURL}${endpoint}`, data, 'isFormData:', isFormData);
    
    try {
      const headers = this.getHeaders(true, isFormData);
      console.log('🔐 [ApiService] Headers utilisés pour PUT:', headers);
      
      const requestOptions = {
        method: 'PUT',
        headers: headers,
      };

      if (isFormData) {
        requestOptions.body = data;
      } else {
        requestOptions.body = JSON.stringify(data);
      }
      
      const response = await fetch(`${this.baseURL}${endpoint}`, requestOptions);
      return await this.handleResponse(response);
    } catch (error) {
      console.error('❌ [ApiService] Erreur dans put:', error);
      throw error;
    }
  }

  async delete(endpoint) {
    console.log('🚀 [ApiService] DELETE request:', `${this.baseURL}${endpoint}`);
    
    try {
      const headers = this.getHeaders();
      console.log('🔐 [ApiService] Headers utilisés pour DELETE:', headers);
      
      const response = await fetch(`${this.baseURL}${endpoint}`, {
        method: 'DELETE',
        headers: headers,
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('❌ [ApiService] Erreur dans delete:', error);
      throw error;
    }
  }
}

export const apiService = new ApiService();